/* eslint-disable no-restricted-imports */
import React, {Fragment, useMemo} from 'react'
import styles from './GameInfoTabContent.module.scss'
import {TranslationObject} from '@colonist/i18n'
import {getDiceSettingText, getExtensionSettingText, getScenarioSettingText, PlayerEnums} from '../../../../../../code/shared/GameEnums'
import {GameModeDataController} from '@colonist/shared-types'
import {MapDataController} from '../../../../../../code/shared/map_data/MapDataController'
import {T} from '../../../common/T'
import {useGameStore} from '../../../store/GameStoreContext'

const SettingItem = ({title, value}: {title: TranslationObject, value: TranslationObject }) => (
    <Fragment key={title.key}>
        <div className={styles.label}><T id={title} /></div>
        <div className={styles.value}><T id={value} /></div>
    </Fragment>
)

export const GameInfoTabContent = () => {
    const gameSettings = useGameStore((state) => state.gameSettings)
    const gameSettingsTexts = useMemo(() => {
        const isKarmaActive = gameSettings.isKarmaActive
        const settings: [TranslationObject, TranslationObject][] = [
            [
                {key: 'strings:game.settings.gameInfoTab.vpToWin.title'},
                {key: 'strings:colonistCommon.utils.#buffer', options: {value: gameSettings.victoryPointsToWin}},
            ],
            [
                {key: 'strings:game.settings.gameInfoTab.cardDiscardLimit.title'},
                {key: 'strings:colonistCommon.utils.#buffer', options: {value: gameSettings.cardDiscardLimit}},
            ],
            [
                {key: 'strings:game.settings.gameInfoTab.gameSpeed.title'},
                PlayerEnums.getSpeedSettingText(gameSettings.gameSpeed),
            ],
            [
                {key: 'strings:game.settings.gameInfoTab.botSpeed.title'},
                PlayerEnums.getBotSpeedSettingText(gameSettings.botSpeed),
            ],
            [
                {key: 'strings:game.settings.gameInfoTab.gameMode.title'},
                GameModeDataController.getModeName(gameSettings.modeSetting),
            ],
            [
                {key: 'strings:game.settings.gameInfoTab.scenario.title'},
                getScenarioSettingText(gameSettings.scenarioSetting),
            ],
            [
                {key: 'strings:game.settings.gameInfoTab.map.title'},
                MapDataController.getMapName(gameSettings.mapSetting),
            ],
            [
                {key: 'strings:game.settings.gameInfoTab.extension.title'},
                getExtensionSettingText(gameSettings.extensionSetting),
            ],
            [
                {key: 'strings:game.settings.gameInfoTab.dice.title'},
                getDiceSettingText(gameSettings.diceSetting),
            ],
            [
                {key: 'strings:game.settings.gameInfoTab.karma.title'},
                {key: `strings:game.settings.gameInfoTab.karma.options.${isKarmaActive ? 'Active' : 'Inactive'}`},
            ],
            [
                {key: 'strings:game.settings.gameInfoTab.bankCards.title'},
                {key: `strings:game.settings.gameInfoTab.bankCards.options.${gameSettings.hideBankCards ? 'Hidden' : 'Showing'}`},
            ],
            [
                {key: 'strings:game.settings.gameInfoTab.friendlyRobber.title'},
                {key: `strings:game.settings.gameInfoTab.friendlyRobber.options.${gameSettings.friendlyRobber ? 'Active' : 'Inactive'}`},
            ],
        ]

        return settings
    }, [gameSettings])

    return <div className={styles.container}>
        {gameSettingsTexts.map(([title, value]) => <SettingItem
            key={title.key}
            title={title}
            value={value}
        />)}
    </div>
}
